module.exports = __webpack_public_path__ + "static/media/anatomia.e6f829d9.png";